export default __webpack_public_path__ + "static/media/16.b089ed25.svg";